import i18n from '../../i18n';

const VisitorInterviewBranch = [
    {
        id: 1,
        value: i18n.t('data2.branchNotSelected'),
        key: i18n.t('data2.branchSelect')
    },
    {
        id: 2,
        value: i18n.t('data2.branchCS'),
        key: i18n.t('data2.branchCS')
    },
    {
        id: 3,
        value: i18n.t('data2.branchIS'),
        key: i18n.t('data2.branchIS')
    },
    {
        id: 4,
        value: i18n.t('data2.branchEC'),
        key: i18n.t('data2.branchEC')
    },
    {
        id: 5,
        value: i18n.t('data2.branchMCA'),
        key: i18n.t('data2.branchMCA')
    },
    {
        id: 6,
        value: i18n.t('data2.branchOthers'),
        key: i18n.t('data2.branchOthers')

    }
];

export default VisitorInterviewBranch